import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { useOutletContext, useLocation } from 'react-router-dom';

import PageLoader from '../../../../components/loaders/PageLoader';
import StructureLogHeader from '../../components/StructureLog/StructureLogHeader';
import StructureLogFilters from '../../components/StructureLog/StructureLogFilters';
import StructureLogTable from '../../components/StructureLog/StructureLogTable';

import { useStructureLogs } from '../../hooks/useStructureLogs';
import styles from './StructureLog.styles';

const todayStr = new Date().toISOString().split('T')[0];

export default function StructureLog() {
  const { isSidebarExpanded } = useOutletContext();
  const location = useLocation();

  const preselectedFile = location.state?.fileName ?? null;
  
  const statusFromNav = location.state?.status;
  const initialStatus =
    statusFromNav === null
      ? []                                   
      : Array.isArray(statusFromNav)
        ? statusFromNav                      
        : [];                        

  const [searchQuery, setSearchQuery] = useState('');
  const { rows, dateRange, setDateRange, loading, refreshing } =
    useStructureLogs({ start: todayStr, end: todayStr });

  const [filters, setFilters] = useState({
    fileName: preselectedFile ? [preselectedFile] : [],
    status: initialStatus,
    reqtype: [],
  });

  const fileNameOptions = useMemo(
    () => [...new Set(rows.map(r => r.fileName).filter(Boolean))],
    [rows]
  );
  const statusOptions = useMemo(
    () => [...new Set(rows.map(r => r.status).filter(Boolean))],
    [rows]
  );
  const reqTypeOptions = useMemo(
    () => [...new Set(rows.map(r => r.reqtype).filter(Boolean))],
    [rows]
  );

  const filteredRows = useMemo(() => {
    const fileNamesActive = Array.isArray(filters.fileName) && filters.fileName.length > 0;
    const statusActive    = Array.isArray(filters.status)   && filters.status.length > 0;
    const reqtypeActive   = Array.isArray(filters.reqtype)  && filters.reqtype.length > 0;

    return rows.filter((r) => {
      if (fileNamesActive && !filters.fileName.includes(r.fileName)) return false;
      if (statusActive    && !filters.status.includes(r.status))     return false;
      if (reqtypeActive   && !filters.reqtype.includes(r.reqtype))   return false;

      if (searchQuery) {
        const hay = `${r.fileName} ${r.status} ${r.reqtype} ${r.message}`.toLowerCase();
        if (!hay.includes(searchQuery.toLowerCase())) return false;
      }
      return true;
    });
  }, [rows, filters, searchQuery]);

  return (
    <Box
      sx={{
        ...styles.fileContent,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded ? 'calc(100vw - 240px)' : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      {loading ? (
        <PageLoader />
      ) : (
        <>
          <StructureLogHeader
            title="Structure Loader Log"
            onSearch={() => {}}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />

          <StructureLogFilters
            filters={filters}
            setFilters={setFilters}
            dateRange={dateRange}
            setDateRange={setDateRange}
            fileNameOptions={fileNameOptions}
            statusOptions={statusOptions}
            reqTypeOptions={reqTypeOptions}
          />

          <StructureLogTable rows={filteredRows} refreshing={refreshing} />
        </>
      )}
    </Box>
  );
}
